import { Box, Paper, Tab, Tabs } from '@mui/material'
import { OverviewView } from './Overview.view'
import { PlannedProductionView } from './PlannedProduction.view'
import { Page } from 'Common/Page/Page'
import { TabPanel, TabContext } from '@mui/lab'
import { Button, PageHeader } from 'Common/Supplyvue-ui'
import { useParams, useNavigate } from 'react-router-dom'
import { CloudDownload } from '@mui/icons-material'
import { useState } from 'react'
import { OperationalPlanDownloadModal } from './OperationalPlanDownload.modal'
import FactoryIcon from '@mui/icons-material/Factory'
import { useOperationalPlan } from 'Features/OperationalPlanner/OperationalPlan.data'

const TABS = {
  OVERVIEW: 'overview',
  PLANNED_PRODUCTION: 'planned-production',
}

export const WorkCentreSummary = () => {
  const { planId } = useParams<{ planId: string }>()
  const [selectedTab, setSelectedTab] = useState(TABS.OVERVIEW)
  const [isModalOpenState, setIsModalOpenState] = useState(false)

  const navigate = useNavigate()

  const { data } = useOperationalPlan('operational-plans')
  const { plannedProductionAccess } = data ?? {}
  const handleDownloadClick = () => {
    setIsModalOpenState(true)
  }

  return (
    <Page>
      <Box
        sx={{ width: '100%' }}
        display="flex"
        flexDirection="column"
        flex="auto"
      >
        <PageHeader
          title="Plan version"
          rightElement={
            <Box display="flex" flexDirection="row" justifyContent="flex-end">
              <Box display="flex">
                <Box>
                  <Button
                    startIcon={<CloudDownload />}
                    variant="outlined"
                    color="primary"
                    onClick={handleDownloadClick}
                  >
                    Download
                  </Button>
                </Box>
                <Box ml={2}>
                  <Button
                    startIcon={<FactoryIcon />}
                    variant="contained"
                    color="primary"
                    onClick={() => navigate(`/plan/${planId}/workcentres`)}
                  >
                    Dashboard
                  </Button>
                </Box>
              </Box>
            </Box>
          }
        />
        <TabContext value={selectedTab}>
          <Box mb={1}>
            <Paper>
              <Tabs
                value={selectedTab}
                indicatorColor="primary"
                textColor="primary"
                onChange={(_event, newValue) => setSelectedTab(newValue)}
              >
                <Tab label="Overview" value={TABS.OVERVIEW} />
                {plannedProductionAccess && (
                  <Tab
                    label="Planned production"
                    value={TABS.PLANNED_PRODUCTION}
                  />
                )}
              </Tabs>
            </Paper>
          </Box>

          <Box>
            <TabPanel value={TABS.OVERVIEW} sx={{ padding: 0 }}>
              <OverviewView />
            </TabPanel>
            <TabPanel value={TABS.PLANNED_PRODUCTION} sx={{ padding: 0 }}>
              <PlannedProductionView />
            </TabPanel>
          </Box>
        </TabContext>
      </Box>
      <OperationalPlanDownloadModal
        isModalOpen={isModalOpenState}
        handleModalCancel={() => setIsModalOpenState(false)}
        planId={planId as string}
      />
    </Page>
  )
}
